"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _style = _interopRequireDefault(require("./style.css"));
var _lounge = _interopRequireDefault(require("./lounge.svg"));
var _thumbnail = _interopRequireDefault(require("./thumbnail.png"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = {
  name: 'Green Lounge',
  className: _style["default"].background,
  assets: [_lounge["default"]],
  imageUrl: _lounge["default"],
  thumbnail: _thumbnail["default"]
};